
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Products from "../pages/products/page";
import Contact from "../pages/contact/page";
import Sustainability from "../pages/sustainability/page";
import AdminPanel from "../pages/admin/page";
import LeatherJackets from "../pages/products/categories/LeatherJackets";
import ShearlingOuterwear from "../pages/products/categories/ShearlingOuterwear";
import PuFauxFur from "../pages/products/categories/PuFauxFur";
import DownJackets from "../pages/products/categories/DownJackets";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/products/leather-garments",
    element: <LeatherJackets />,
  },
  {
    path: "/products/shearling",
    element: <ShearlingOuterwear />,
  },
  {
    path: "/products/pu-faux-fur",
    element: <PuFauxFur />,
  },
  {
    path: "/products/puffer",
    element: <DownJackets />,
  },
  {
    path: "/sustainability",
    element: <Sustainability />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/admin",
    element: <AdminPanel />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
